import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const CreateAssetPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [asset, setAsset] = useState({
    proveedor: '', id_proveedor: '', id_prestamo: '', id_finca: '',
    referencia_catastral: '', direccion: '', municipio: '', provincia: '',
    codigo_postal: '', tipo_activo: '', metros: '', ocupacion: '',
    deuda_reclamada: '', principal: '', intereses: '', costas: '',
    tasacion: '', precio_compra: '', estado_procesal: '',
    fecha_subasta: '', cargas: '', ibi_pendiente: '', comunidad_pendiente: '',
    observaciones_importacion: '', estado: 'nuevo', prioridad: 'normal', fase: 'revision'
  });

  const set = (field, val) => setAsset(prev => ({ ...prev, [field]: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const data = { ...asset };
      ['metros','deuda_reclamada','principal','intereses','costas','tasacion','precio_compra','cargas','ibi_pendiente','comunidad_pendiente'].forEach(f => {
        data[f] = data[f] ? parseFloat(data[f]) : null;
      });
      const res = await axios.post(`${API}/assets`, data, { withCredentials: true });
      toast.success('Activo creado');
      navigate(`/activos/${res.data.id}`);
    } catch (err) {
      toast.error('Error al crear: ' + (err.response?.data?.detail || err.message));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto" data-testid="create-asset-page">
      <div className="flex items-center gap-4 mb-8">
        <button onClick={() => navigate('/activos')} className="text-slate-500 hover:text-slate-700 text-2xl">&larr;</button>
        <h1 className="heading-1">Crear Activo</h1>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <Section title="Identificación">
          <Row>
            <Field label="Proveedor"><input className="input-base" value={asset.proveedor} onChange={e => set('proveedor', e.target.value)} data-testid="input-proveedor" /></Field>
            <Field label="ID Proveedor"><input className="input-base" value={asset.id_proveedor} onChange={e => set('id_proveedor', e.target.value)} data-testid="input-id-proveedor" /></Field>
            <Field label="Referencia Catastral"><input className="input-base" value={asset.referencia_catastral} onChange={e => set('referencia_catastral', e.target.value)} data-testid="input-ref-catastral" /></Field>
          </Row>
        </Section>

        <Section title="Ubicación">
          <Row>
            <Field label="Dirección" span={2}><input className="input-base" value={asset.direccion} onChange={e => set('direccion', e.target.value)} data-testid="input-direccion" /></Field>
            <Field label="Código Postal"><input className="input-base" value={asset.codigo_postal} onChange={e => set('codigo_postal', e.target.value)} data-testid="input-cp" /></Field>
          </Row>
          <Row>
            <Field label="Municipio"><input className="input-base" value={asset.municipio} onChange={e => set('municipio', e.target.value)} data-testid="input-municipio" /></Field>
            <Field label="Provincia"><input className="input-base" value={asset.provincia} onChange={e => set('provincia', e.target.value)} data-testid="input-provincia" /></Field>
          </Row>
        </Section>

        <Section title="Características">
          <Row>
            <Field label="Tipo de Activo">
              <select className="input-base" value={asset.tipo_activo} onChange={e => set('tipo_activo', e.target.value)} data-testid="input-tipo-activo">
                <option value="">Seleccionar</option>
                <option value="vivienda">Vivienda</option><option value="local">Local</option><option value="oficina">Oficina</option>
                <option value="nave">Nave</option><option value="garaje">Garaje</option><option value="terreno">Terreno</option><option value="otro">Otro</option>
              </select>
            </Field>
            <Field label="Metros (m²)"><input type="number" className="input-base" value={asset.metros} onChange={e => set('metros', e.target.value)} data-testid="input-metros" /></Field>
            <Field label="Ocupación">
              <select className="input-base" value={asset.ocupacion} onChange={e => set('ocupacion', e.target.value)} data-testid="input-ocupacion">
                <option value="">Seleccionar</option><option value="libre">Libre</option><option value="ocupado_titulo">Ocupado con título</option><option value="ocupado_sin_titulo">Ocupado sin título</option><option value="desconocido">Desconocido</option>
              </select>
            </Field>
          </Row>
        </Section>

        <Section title="Datos Económicos">
          <Row>
            <Field label="Precio Compra (€)"><input type="number" className="input-base" value={asset.precio_compra} onChange={e => set('precio_compra', e.target.value)} data-testid="input-precio-compra" /></Field>
            <Field label="Deuda Reclamada (€)"><input type="number" className="input-base" value={asset.deuda_reclamada} onChange={e => set('deuda_reclamada', e.target.value)} data-testid="input-deuda" /></Field>
            <Field label="Tasación (€)"><input type="number" className="input-base" value={asset.tasacion} onChange={e => set('tasacion', e.target.value)} data-testid="input-tasacion" /></Field>
          </Row>
          <Row>
            <Field label="Cargas (€)"><input type="number" className="input-base" value={asset.cargas} onChange={e => set('cargas', e.target.value)} data-testid="input-cargas" /></Field>
          </Row>
        </Section>

        <Section title="Estado">
          <Row>
            <Field label="Estado">
              <select className="input-base" value={asset.estado} onChange={e => set('estado', e.target.value)} data-testid="input-estado">
                <option value="activo">Activo</option><option value="standby">Standby</option><option value="cerrado">Cerrado</option><option value="papelera">Papelera</option>
              </select>
            </Field>
            <Field label="Prioridad">
              <select className="input-base" value={asset.prioridad} onChange={e => set('prioridad', e.target.value)} data-testid="input-prioridad">
                <option value="baja">Baja</option><option value="normal">Normal</option><option value="alta">Alta</option><option value="urgente">Urgente</option>
              </select>
            </Field>
          </Row>
        </Section>

        <Section title="Observaciones">
          <textarea className="input-base min-h-[100px] w-full" value={asset.observaciones_importacion} onChange={e => set('observaciones_importacion', e.target.value)} placeholder="Observaciones..." data-testid="input-observaciones" />
        </Section>

        <div className="flex justify-end gap-3 pb-8">
          <button type="button" onClick={() => navigate('/activos')} className="btn-secondary" data-testid="cancel-btn">Cancelar</button>
          <button type="submit" disabled={saving} className="btn-primary" data-testid="submit-btn">
            {saving ? 'Guardando...' : 'Crear Activo'}
          </button>
        </div>
      </form>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="card-base p-6"><h2 className="heading-3 mb-4">{title}</h2>{children}</div>
);
const Row = ({ children }) => <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-3">{children}</div>;
const Field = ({ label, children, span }) => (
  <div className={`space-y-1 ${span === 2 ? 'lg:col-span-2' : ''}`}>
    <label className="text-sm text-slate-600">{label}</label>
    {children}
  </div>
);

export default CreateAssetPage;
